const winners = document.querySelector('.winners');
const winnersSlider = winners ? winners.querySelector('.winners__slider') : null;
const winnersSlides = winners ? winners.querySelectorAll('.swiper-slide') : null;
let swiper;

const setSwiper = () => {
// eslint-disable-next-line no-undef
  swiper = new Swiper(winnersSlider, {
    slidesPerView: 'auto',
    freeMode: true,
    initialSlide: winnersSlides.length - 1,
    // slideToClickedSlide: true,
    navigation: {
      nextEl: '.winners__btns .swiper-button-next',
      prevEl: '.winners__btns .swiper-button-prev',
    },
  });
};


const initWinnersSlider = () => {
  if (!winners) {
    return;
  }

  setSwiper(winnersSlider);
};

export {initWinnersSlider};
